import axios from "axios";
import { fr } from "date-fns/locale";

const AttendanceDetailsService = {
  async getAttendanceDetails(bdate, sno = "", loc = "") {
    try {
      // Use relative URL — axios.defaults.baseURL = "https://daladamaligawatest.dockyardsoftware.com/"
      const url = `Attendence/GetAttendenceDetails?sno=${sno}&bdate=${bdate}&loc=${loc}`;
      console.log("AttendanceDetails fetching URL:", url);

      const response = await axios.get(url);

      // Log full raw response to check actual keys
      console.log("AttendanceDetails RAW response:", response.data);
      console.log("AttendanceDetails response keys:", response.data ? Object.keys(response.data) : "null");

      const rd = response.data;

      // Try all known response key patterns used across this project
      if (rd && Array.isArray(rd.resultSet) && rd.resultSet.length >= 0) {
        return rd.resultSet;
      }
      if (rd && Array.isArray(rd.ResultSet) && rd.ResultSet.length >= 0) {
        return rd.ResultSet;
      }
      if (rd && Array.isArray(rd.AttendancList)) {
        return rd.AttendancList;
      }
      if (rd && Array.isArray(rd.AttendanceList)) {
        return rd.AttendanceList;
      }
      if (rd && Array.isArray(rd.Data)) {
        return rd.Data;
      }
      if (Array.isArray(rd)) {
        return rd;
      }

      console.warn("AttendanceDetails: no matching response key found. Full data:", rd);
      return [];
    } catch (error) {
      console.error("Error fetching attendance details:", error);
      throw error;
    }
  },

  async getMonthly (fromDate, toDate, loc = ""){
    try{
      const [later, earlier] = fromDate >= toDate ? [fromDate, toDate] : [toDate, fromDate];
      const url = `/UserDetails/GetAttendenceDetailsForLocation?fromDate=${later}&toDate=${earlier}&loc=${encodeURIComponent(loc)}`;
      const response = await axios.get(url);
      const rd = response.data||{};
      const rows = rd.ResultSet ?? rd.resultSet;
      if(Array.isArray(rows)) return rows;
      console.warn("Monthly attendance: unexpected response", rd);
      return [];
    }catch(error){
      console.error("Error fetching monthly attendance", error);
      throw error;
    }
  },

  async getLocations(){
    try{
      const response = await axios.get("/UserDetails/Locations");
      const rd = response.data || {};
      const rows = rd.ResultSet ?? rd.resultSet;
      return Array.isArray(rows) ? rows : [];
    }catch(error){
      console.error("Error fetching locations", error);
      throw error;
    }
  },

};

export default AttendanceDetailsService;

